const threshold = 1024;
const decimalPlaceMultiplier = 1;

export const prettyPrintFileSize = (fileSize: number) => {
  let orderOfMagnitude = 0;

  while (fileSize >= threshold) {
    fileSize = Math.round((fileSize / threshold) * decimalPlaceMultiplier) / decimalPlaceMultiplier;
    orderOfMagnitude += 1;
  }

  return `${fileSize} ${getUnit(orderOfMagnitude)}`;
};

const getUnit = (orderOfMagnitude: number) => {
  switch (orderOfMagnitude) {
    case 0:
      return 'B';
    case 1:
      return 'KB';
    case 2:
      return 'MB';
    case 3:
    default:
      return 'GB';
  }
};
